import Vue from 'vue'
import VueRouter from 'vue-router'
import TenderAgency from '../views/BiddingFees/TenderAgency.vue'
import SupervisionTender from '../views/BiddingFees/SupervisionTender.vue'
import DesignTender from '../views/BiddingFees/DesignTender.vue'
import GoodsTender from '../views/BiddingFees/GoodsTender.vue'

import TenderAgency2011 from '../views/BiddingFees[2011]/TenderAgency.vue'
import SupervisionTender2011 from '../views/BiddingFees[2011]/SupervisionTender.vue'
import GoodsTender2011 from '../views/BiddingFees[2011]/GoodsTender.vue'


import SuperVision from '../views/SupervisorFees/SuperVision.vue'
import SuperVision2018 from '../views/SupervisorFees/SuperVision2018.vue'
import QuotaValuation from '../views/SocialFees/13QuotaValuation.vue'
import DesignService from '../views/DesignFees/DesignService.vue'
import DesignService2018 from '../views/DesignFees/DesignService2018.vue'
import SettlementReview from '../views/SocialFees/15SettlementReview.vue'
import ManifestValuation from '../views/SocialFees/12ManifestValuation.vue'
import ProcessValuation from '../views/SocialFees/17ProcessValuation.vue'
import ProcessNoValuation from '../views/SocialFees/18ProcessNoValuation.vue'
import FinancialFinal from '../views/FinancialFinal.vue'
import InvestmentEstimation from '../views/SocialFees/7InvestmentEstimation.vue'
import DesignEstimate from '../views/SocialFees/8DesignEstimate.vue'
import BillOfQuantities from '../views/SocialFees/10BillOfQuantities.vue'
import TenderOffer from '../views/SocialFees/11TenderOffer.vue'
import SettlementPreparation from '../views/SocialFees/14SettlementPreparation.vue'
import SettlementOfAccount from '../views/SocialFees/16SettlementOfAccount.vue'


import ConstructionManagement from '../views/ConstructionManagement.vue'
import ConstructionManagement2016 from '../views/ConstructionManagement2016.vue'
import ConstructionManagement26 from '../views/26ConstructionManagement.vue'



import bzhjyxbgFee from '../views/32hjyxpjf/33bzhjyxbg.vue'
import bzhjyxbgbFee from '../views/32hjyxpjf/34bzhjyxbgb.vue'
import pghjyxbgsFee from '../views/32hjyxpjf/35pghjyxbgs.vue'
import pghjyxbgbFee from '../views/32hjyxpjf/36pghjyxbgb.vue'
import bzxmjysFee from '../views/37jsxmqqgzzxf/38bzxmjys.vue'
import bzkxxyjbgFee from '../views/37jsxmqqgzzxf/39bzkxxyjbg.vue'
import pgxmjysFee from '../views/37jsxmqqgzzxf/40pgxmjys.vue'

import pgkxxyybgFee from '../views/37jsxmqqgzzxf/41pgkxxyybg.vue'
import stbcfabzfFee from '../views/42stbcf/43stbcfabzf.vue'
import stbcjcfFee from '../views/42stbcf/44stbcjcf.vue'
import stbcssjgysFee from '../views/42stbcf/45stbcssjgys.vue'

import stbcjswjFee from '../views/42stbcf/46stbcjswj.vue'

import ytgcsjfFee from '../views/47ytgcsjf/ytgcsjf.vue'

import jsqlxFee from '../views/52jsqlx/jsqlx.vue'

import ygckcsjsfwjzFee from '../views/54sgtscf/55ygckcsjsfwjz.vue'
import ygcgystzebljfFee from '../views/54sgtscf/56ygcgystzebljf.vue'
import azjzmjjfFee from '../views/54sgtscf/57azjzmjjf.vue'

import rmfdgcFee from '../views/58dljsgcjnpgf/59hlfdgc/60rmfdgc.vue'
import rqzqlhxhdzFee from '../views/58dljsgcjnpgf/59hlfdgc/61rqzqlhxhdz.vue'
import jlzgcFee from '../views/58dljsgcjnpgf/62dwgc/63jlzgc.vue'
import zlsdxlgcFee from '../views/58dljsgcjnpgf/62dwgc/64zlsdxlgc.vue'
import bdzgcFee from '../views/58dljsgcjnpgf/62dwgc/65bdzgc.vue'
import jlsdxlgcFee from '../views/58dljsgcjnpgf/62dwgc/66jlsdxlgc.vue'

import rmfdgcBuild from '../views/170dljsgcjnpgf/171hlfdgc/172rmfdgc.vue'
import rqzqlhxhdzBuild from '../views/170dljsgcjnpgf/171hlfdgc/173rqzqlhxhdz.vue'
import jlzgcBuild from '../views/170dljsgcjnpgf/174dwgc/175jlzgc.vue'
import zlsdxlgcBuild from '../views/170dljsgcjnpgf/174dwgc/176zlsdxlgc.vue'
import bdzgcBuild from '../views/170dljsgcjnpgf/174dwgc/177bdzgc.vue'
import jlsdxlgcBuild from '../views/170dljsgcjnpgf/174dwgc/178jlsdxlgc.vue'

import qgpdldzjFee from '../views/67pdldzj/68qgpdldzj.vue'

import sczbfFee from '../views/69sczbf/70sczbf.vue'

import cdzbjlsssfFee from '../views/75cdzbjlsssf/76cdzbjlsssf.vue'

import ldaqwspsFee from '../views/77ldaqwsps/78ldaqwsps.vue'
import dljsgcaqwsypjfFee from '../views/77ldaqwsps/79dljsgcaqwsypjf.vue'

import dljsgcdzaqxpjFee from '../views/80dzaqxpjf/81dljsgcdzaqxpj.vue'

import gczljcjcfFee from '../views/82xcjchclsysf/83gczljcjcf.vue'
import xmysfgfFee from '../views/82xcjchclsysf/84xmysfgf.vue'

import gyjtysyyFee from '../views/85hyhwrdjzf/86hysyjzsbz/88zhzdyh/96gyjtysyy.vue'
import czjsthFee from '../views/85hyhwrdjzf/86hysyjzsbz/88zhzdyh/97czjsth.vue'
import nythzdyhFee from '../views/85hyhwrdjzf/86hysyjzsbz/88zhzdyh/98nythzdyh.vue'

import ftsgzwyhFee from '../views/85hyhwrdjzf/86hysyjzsbz/92gzwyh/99ftsgzwyh.vue'
import kjqlhdsdyhFee from '../views/85hyhwrdjzf/86hysyjzsbz/92gzwyh/100kjqlhdsdyh.vue'
import tsgzwyhFee from '../views/85hyhwrdjzf/86hysyjzsbz/92gzwyh/101tsgzwyh.vue'

import gcxsyhFee from '../views/85hyhwrdjzf/86hysyjzsbz/93whyh/102gcxsyh.vue'
import ytyhFee from '../views/85hyhwrdjzf/86hysyjzsbz/93whyh/103ytyh.vue'
import whsylcyhFee from '../views/85hyhwrdjzf/86hysyjzsbz/93whyh/104whsylcyh.vue'
import qtwhyhFee from '../views/85hyhwrdjzf/86hysyjzsbz/93whyh/105qtwhyh.vue'

import ycyhFee from '../views/85hyhwrdjzf/86hysyjzsbz/94kfsyh/106ycyh.vue'
import kfsylyyhFee from '../views/85hyhwrdjzf/86hysyjzsbz/94kfsyh/107kfsylyyh.vue'
import zyhdmdyhFee from '../views/85hyhwrdjzf/86hysyjzsbz/94kfsyh/108zyhdmdyh.vue'
import qtkfsyhFee from '../views/85hyhwrdjzf/86hysyjzsbz/94kfsyh/109qtkfsyh.vue'

import rgdsyqkcyhFee from '../views/85hyhwrdjzf/86hysyjzsbz/95qtyh/110rgdsyqkcyh.vue'
import ptsyqkcyhFee from '../views/85hyhwrdjzf/86hysyjzsbz/95qtyh/111ptsyqkcyh.vue'
import hddlgdyhFee from '../views/85hyhwrdjzf/86hysyjzsbz/95qtyh/112hddlgdyh.vue'
import hsdkckcyhFee from '../views/85hyhwrdjzf/86hysyjzsbz/95qtyh/113hsdkckcyh.vue'
import qpskyhFee from '../views/85hyhwrdjzf/86hysyjzsbz/95qtyh/114qpskyh.vue'
import wsdbpfyhFee from '../views/85hyhwrdjzf/86hysyjzsbz/95qtyh/115wsdbpfyh.vue'
import wlpsyhFee from '../views/85hyhwrdjzf/86hysyjzsbz/95qtyh/116wlpsyh.vue'
import qdyhFee from '../views/85hyhwrdjzf/86hysyjzsbz/95qtyh/117qdyh.vue'
import zzyhFee from '../views/85hyhwrdjzf/86hysyjzsbz/95qtyh/118zzyh.vue'
import jtyxpjfFee from '../views/168jtyxpjf/169jtyxpjf.vue'

import lyylydFee from '../views/85hyhwrdjzf/87wjmhdsyjzsbz/lyylyd.vue'
import jtysydFee from '../views/85hyhwrdjzf/87wjmhdsyjzsbz/jtysyd.vue'
import gyccydFee from '../views/85hyhwrdjzf/87wjmhdsyjzsbz/gyccyd.vue'
import yyydFee from '../views/85hyhwrdjzf/87wjmhdsyjzsbz/yyyd.vue'
import nlmyydFee from '../views/85hyhwrdjzf/87wjmhdsyjzsbz/nlmyyd.vue'
import kzsnyydFee from '../views/85hyhwrdjzf/87wjmhdsyjzsbz/kzsnyyd.vue'
import cxjsydFee from '../views/85hyhwrdjzf/87wjmhdsyjzsbz/cxjsyd.vue'

import gcsyclFee from '../views/49kcf/gcsycl.vue'
import dsclfFee from '../views/49kcf/dsclf.vue'
import slsdgcFee from '../views/49kcf/slsdgc.vue'
Vue.use(VueRouter)

const routes = [
  //工程招标代理收费
  {
    path: '/',
    name: 'tenderAgency2011',
    component: TenderAgency2011
  },
  //监理招标代理收费(作为服务招标通用模版)
  {
    path: '/supervisionTender2011',
    name: 'supervisionTender2011',
    component: SupervisionTender2011
  },
  //设计招标代理收费
  {
    path: '/designTender2011',
    name: 'designTender2011',
    component: DesignTender
  },//货物招标代理收费
  {
    path: '/goodsTender2011',
    name: 'goodsTender2011',
    component: GoodsTender2011
  },

  //工程招标代理收费
  {
    path: '/tenderAgency2002',
    name: 'tenderAgency',
    component: TenderAgency
  },
  //监理招标代理收费(作为服务招标通用模版)
  {
    path: '/supervisionTender2002',
    name: 'supervisionTender',
    component: SupervisionTender
  },//货物招标代理收费
  {
    path: '/goodsTender2002',
    name: 'goodsTender',
    component: GoodsTender
  },






  // 以下为社会中介机构审计(查)费
  //7 投资估算编制或审核
  {
    path: '/investmentEstimation',
    name: 'investmentEstimation',
    component: InvestmentEstimation
  },
  //8 设计概算编制或审核
  {
    path: '/designEstimate',
    name: 'designEstimate',
    component: DesignEstimate
  },
  //9 清单计价法预算编制费
  //10 工程量清单单独编制或审核
  {
    path: '/billOfQuantities',
    name: 'billOfQuantities',
    component: BillOfQuantities
  },
  //11 投标报价编制
  {
    path: '/tenderOffer',
    name: 'tenderOffer',
    component: TenderOffer
  },
  //12 工程量清单及预算、招标控制价的编制或审核
  {
    path: '/manifestValuation',
    name: 'manifestValuation',
    component: ManifestValuation
  },
  //13 定额计价法预算编制服务费计算表
  {
    path: '/quotaValuation',
    name: 'quotaValuation',
    component: QuotaValuation
  },
  //14 工程结算编制
  {
    path: '/settlementPreparation',
    name: 'settlementPreparation',
    component: SettlementPreparation
  },
  //15 工程结算审核费用计算模版
  {
    path: '/settlementReview',
    name: 'settlementReview',
    component: SettlementReview
  },
  //16 竣工决算编制或审核
  {
    path: '/settlementOfAccount',
    name: 'settlementOfAccount',
    component: SettlementOfAccount
  },
  //17 全过程跟审咨询费 
  {
    path: '/processValuation',
    name: 'processValuation',
    component: ProcessValuation
  },
  //18 全过程跟审咨询费（不含预算编制费）
  {
    path: '/processNoValuation',
    name: 'processNoValuation',
    component: ProcessNoValuation
  },

  //其他
  //施工监理服务费计算模版
  {
    path: '/superVision',
    name: 'superVision',
    component: SuperVision
  },
  {
    path: '/superVision2018',
    name: 'superVision2018',
    component: SuperVision2018
  },



  //设计监理服务费计算模版
  {
    path: '/designService',
    name: 'designService',
    component: DesignService
  },
  //设计监理服务费计算模版
  {
    path: '/designService2018',
    name: 'designService2018',
    component: DesignService2018
  },

  //财务决算审核费用计算模版
  {
    path: '/financialFinal',
    name: 'financialFinal',
    component: FinancialFinal
  },
  //24建设单位管理费财建[2002]394号.pdf
  {
    path: '/constructionManagement',
    name: 'constructionManagement',
    component: ConstructionManagement
  },
  //180建设单位管理费财建[2016]249号.pdf
  {
    path: '/constructionManagement2016',
    name: 'constructionManagement2016',
    component: ConstructionManagement2016
  },
  //建设单位管理费
  {
    path: '/26constructionManagement',
    name: '26constructionManagement',
    component: ConstructionManagement26
  },

  //编制环境影响报告书(含大纲)
  {
    path: '/bzhjyxbgFee',
    name: 'bzhjyxbgFee',
    component: bzhjyxbgFee
  },
  //编制环境影响报告表
  {
    path: '/bzhjyxbgbFee',
    name: 'bzhjyxbgbFee',
    component: bzhjyxbgbFee
  },
  //评估环境影响报告书(含大纲)
  {
    path: '/pghjyxbgsFee',
    name: 'pghjyxbgsFee',
    component: pghjyxbgsFee
  },
  //评估环境影响报告表
  {
    path: '/pghjyxbgbFee',
    name: 'pghjyxbgbFee',
    component: pghjyxbgbFee
  },


  //编制项目建议书
  {
    path: '/bzxmjysFee',
    name: 'bzxmjysFee',
    component: bzxmjysFee
  },
  //编制可行性研究报告
  {
    path: '/bzkxxyjbgFee',
    name: 'bzkxxyjbgFee',
    component: bzkxxyjbgFee
  },
  //评估项目建议书
  {
    path: '/pgxmjysFee',
    name: 'pgxmjysFee',
    component: pgxmjysFee
  },
  // 评估可行性研究报告
  {
    path: '/pgkxxyybgFee',
    name: 'pgkxxyybgFee',
    component: pgkxxyybgFee
  },
  // 水士保持方案编制费
  {
    path: '/stbcfabzfFee',
    name: 'stbcfabzfFee',
    component: stbcfabzfFee
  },

  // 水土保持监测费
  {
    path: '/stbcjcfFee',
    name: 'stbcjcfFee',
    component: stbcjcfFee
  },


  //  水士保持设施竣工验收技术评估报告编制费
  {
    path: '/stbcssjgysFee',
    name: 'stbcssjgysFee',
    component: stbcssjgysFee
  },

  // 水士保持技术文件技术咨询服务费
  {
    path: '/stbcjswjFee',
    name: 'stbcjswjFee',
    component: stbcjswjFee
  },

  //  岩土工程设计收费
  {
    path: '/ytgcsjfFee',
    name: 'ytgcsjfFee',
    component: ytgcsjfFee
  },


  //  建设期利息
  {
    path: '/jsqlxFee',
    name: 'jsqlxFee',
    component: jsqlxFee
  },

  //  全国施工图审查费计算
  //  以工程勘察设计收费为基准
  {
    path: '/ygckcsjsfwjzFee',
    name: 'ygckcsjsfwjzFee',
    component: ygckcsjsfwjzFee
  },
  //  以工程概(预)算投资额比率计费
  {
    path: '/ygcgystzebljfFee',
    name: 'ygcgystzebljfFee',
    component: ygcgystzebljfFee
  },
  //   按照建筑面积计费
  {
    path: '/azjzmjjfFee',
    name: 'azjzmjjfFee',
    component: azjzmjjfFee
  },

  //全国电力建设工程社会稳定风险评估费计算模版
  //火力发电
  //燃煤发电工程
  //rmfdgcFee
  {
    path: '/rmfdgcFee',
    name: 'rmfdgcFee',
    component: rmfdgcFee
  },

  // 燃气-蒸汽联合循环电站
  //rqzqlhxhdzFee
  {
    path: '/rqzqlhxhdzFee',
    name: 'rqzqlhxhdzFee',
    component: rqzqlhxhdzFee
  },

  //电网工程
  //  换流站工程 (含接地极及接地极线路）
  //jlzgcFee
  {
    path: '/jlzgcFee',
    name: 'jlzgcFee',
    component: jlzgcFee
  },
  //   直流输电线路工程
  //zlsdxlgcFee
  {
    path: '/zlsdxlgcFee',
    name: 'zlsdxlgcFee',
    component: zlsdxlgcFee
  },
  // 变电站工程
  //jlzgcFee
  {
    path: '/bdzgcFee',
    name: 'bdzgcFee',
    component: bdzgcFee
  },
  //  交流输电线路工程
  //jlsdxlgcFee
  {
    path: '/jlsdxlgcFee',
    name: 'jlsdxlgcFee',
    component: jlsdxlgcFee
  },

  //全国电力建设工程工程建设项目规划地址费
  //火力发电
  //燃煤发电工程
  //rmfdgcFee
  {
    path: '/rmfdgcBuild',
    name: 'rmfdgcBuild',
    component: rmfdgcBuild
  },

  // 燃气-蒸汽联合循环电站
  //rqzqlhxhdzBuild
  {
    path: '/rqzqlhxhdzBuild',
    name: 'rqzqlhxhdzBuild',
    component: rqzqlhxhdzBuild
  },

  //电网工程
  //  换流站工程 (含接地极及接地极线路）
  //jlzgcBuild
  {
    path: '/jlzgcBuild',
    name: 'jlzgcBuild',
    component: jlzgcBuild
  },
  //   直流输电线路工程
  //zlsdxlgcBuild
  {
    path: '/zlsdxlgcBuild',
    name: 'zlsdxlgcBuild',
    component: zlsdxlgcBuild
  },
  // 变电站工程
  //jlzgcBuild
  {
    path: '/bdzgcBuild',
    name: 'bdzgcBuild',
    component: bdzgcBuild
  },
  //  交流输电线路工程
  //jlsdxlgcBuild
  {
    path: '/jlsdxlgcBuild',
    name: 'jlsdxlgcBuild',
    component: jlsdxlgcBuild
  },

  //  铺底流动资金计算
  //jlsdxlgcFee
  {
    path: '/qgpdldzjFee',
    name: 'qgpdldzjFee',
    component: qgpdldzjFee
  },

  //  生产准备费
  //jlsdxlgcFee
  {
    path: '/sczbfFee',
    name: 'sczbfFee',
    component: sczbfFee
  },


  //  场地准备及临时设施费
  //cdzbjlsssfFee
  {
    path: '/cdzbjlsssfFee',
    name: 'cdzbjlsssfFee',
    component: cdzbjlsssfFee
  },

  //  劳动安全卫生评审费
  //ldaqwspsFee
  {
    path: '/ldaqwspsFee',
    name: 'ldaqwspsFee',
    component: ldaqwspsFee
  },
  //dljsgcaqwsypjfFee
  {
    path: '/dljsgcaqwsypjfFee',
    name: 'dljsgcaqwsypjfFee',
    component: dljsgcaqwsypjfFee
  },
  //  全国电力建设工程地震安全性评价费
  //dljsgcdzaqxpjFee
  {
    path: '/dljsgcdzaqxpjFee',
    name: 'dljsgcdzaqxpjFee',
    component: dljsgcdzaqxpjFee
  },
  // 现场检测和材料试验收费
  // 工程质量检查检测费(光伏发电工程)
  //gczljcjcfFee
  {
    path: '/gczljcjcfFee',
    name: 'gczljcjcfFee',
    component: gczljcjcfFee
  },
  // 项目验收费(光伏发电工程)
  //xmysfgfFee
  {
    path: '/xmysfgfFee',
    name: 'xmysfgfFee',
    component: xmysfgfFee
  },
  // 海域和无人岛金征费
  //海域使用金征收标准
  //填海造地用海
  // 工业、交通运输、渔业基础 设施等填海
  //hyjzfFee
  {
    path: '/gyjtysyyFee',
    name: 'gyjtysyyFee',
    component: gyjtysyyFee
  },
  //  城镇建设填海
  //czjsthFee
  {
    path: '/czjsthFee',
    name: 'czjsthFee',
    component: czjsthFee
  },
  //  农业填海造地用海
  //nythzdyh
  {
    path: '/nythzdyhFee',
    name: 'nythzdyhFee',
    component: nythzdyhFee
  },
  //构筑物用海
  //非透水构筑物用海
  //ftsgzwyhFee
  {
    path: '/ftsgzwyhFee',
    name: 'ftsgzwyhFee',
    component: ftsgzwyhFee
  },
  // 跨海桥梁、海底隧道用海
  //kjqlhdsdyhFee
  {
    path: '/kjqlhdsdyhFee',
    name: 'kjqlhdsdyhFee',
    component: kjqlhdsdyhFee
  },
  //透水构筑物用海
  //tsgzwyhFee
  {
    path: '/tsgzwyhFee',
    name: 'tsgzwyhFee',
    component: tsgzwyhFee
  },
  //围海用海
  //港池、蓄水用海
  //gcxsyhFee
  {
    path: '/gcxsyhFee',
    name: 'gcxsyhFee',
    component: gcxsyhFee
  },
  // 盐田用海
  //ytyhFee
  {
    path: '/ytyhFee',
    name: 'ytyhFee',
    component: ytyhFee
  },

  // 围海式游乐场用海
  //whsylcyh
  {
    path: '/whsylcyhFee',
    name: 'whsylcyhFee',
    component: whsylcyhFee
  },
  // 其他围海用海
  //qtwhyhFee
  {
    path: '/qtwhyhFee',
    name: 'qtwhyhFee',
    component: qtwhyhFee
  },

  //开放式用海
  //浴场用海
  //ycyhFee
  {
    path: '/ycyhFee',
    name: 'ycyhFee',
    component: ycyhFee
  },
  // 开放式游乐场用海
  //kfsylyyhFee
  {
    path: '/kfsylyyhFee',
    name: 'kfsylyyhFee',
    component: kfsylyyhFee
  },

  // 专用航道、锚地用海
  //zyhdmdyhFee
  {
    path: '/zyhdmdyhFee',
    name: 'zyhdmdyhFee',
    component: zyhdmdyhFee
  },
  //  其他开放式用海
  //qtkfsyhFee
  {
    path: '/qtkfsyhFee',
    name: 'qtkfsyhFee',
    component: qtkfsyhFee
  },
  //其它用海
  //人工岛式油气开采用海
  //rgdsyqkcyhFee
  {
    path: '/rgdsyqkcyhFee',
    name: 'rgdsyqkcyhFee',
    component: rgdsyqkcyhFee
  },
  //平台式油气开采用海
  //ptsyqkcyhFee
  {
    path: '/ptsyqkcyhFee',
    name: 'ptsyqkcyhFee',
    component: ptsyqkcyhFee
  },
  //海底电缆管道用海
  //hddlgdyhFee
  {
    path: '/hddlgdyhFee',
    name: 'hddlgdyhFee',
    component: hddlgdyhFee
  },
  //海砂等矿产开采用海
  //hsdkckcyhFee
  {
    path: '/hsdkckcyhFee',
    name: 'hsdkckcyhFee',
    component: hsdkckcyhFee
  },
  //取、排水口用海
  //qpskyhFee
  {
    path: '/qpskyhFee',
    name: 'qpskyhFee',
    component: qpskyhFee
  },
  //污水达标排放用海
  //wsdbpfyhFee
  {
    path: '/wsdbpfyhFee',
    name: 'wsdbpfyhFee',
    component: wsdbpfyhFee
  },
  //温、冷排水用海
  //wlpsyhFee
  {
    path: '/wlpsyhFee',
    name: 'wlpsyhFee',
    component: wlpsyhFee
  },
  //倾倒用海
  //qdyhFee
  {
    path: '/qdyhFee',
    name: 'qdyhFee',
    component: qdyhFee
  },
  //种植用海
  //zzyhFee
  {
    path: '/zzyhFee',
    name: 'zzyhFee',
    component: zzyhFee
  },
  //全国交通影响评价费
  //jtyxpjfFee
  {
    path: '/jtyxpjfFee',
    name: 'jtyxpjfFee',
    component: jtyxpjfFee
  },
  //无居民海岛使用金征收标准
  //旅游娱乐用岛
  //lyylydFee
  {
    path: '/lyylydFee',
    name: 'lyylydFee',
    component: lyylydFee
  },

  //交通运输用岛
  //jtysydFee
  {
    path: '/jtysydFee',
    name: 'jtysydFee',
    component: jtysydFee
  },
  //交通运输用岛
  //gyccydFee
  {
    path: '/gyccydFee',
    name: 'gyccydFee',
    component: gyccydFee
  },
  //渔业用岛
  //yyydFee
  {
    path: '/yyydFee',
    name: 'yyydFee',
    component: yyydFee
  },
  //农林牧业用岛
  //nlmyydFee
  {
    path: '/nlmyydFee',
    name: 'nlmyydFee',
    component: nlmyydFee
  },
  //农林牧业用岛
  //kzsnyydFee
  {
    path: '/kzsnyydFee',
    name: 'kzsnyydFee',
    component: kzsnyydFee
  },
  //城乡建设用岛
  //cxjsydFee
  {
    path: '/cxjsydFee',
    name: 'cxjsydFee',
    component: cxjsydFee
  },
  //水利水电工程勘察
  //slsdgcFee
  {
    path: '/slsdgcFee',
    name: 'slsdgcFee',
    component: slsdgcFee
  },

  //洞室测量费
  //dsclfFee
  {
    path: '/dsclfFee',
    name: 'dsclfFee',
    component: dsclfFee
  },

  //工程水域测量收费
  //gcsyclFee
  {
    path: '/gcsyclFee',
    name: 'gcsyclFee',
    component: gcsyclFee
  }














]

const router = new VueRouter({
  routes
})

export default router
